import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
import signUrl from 'ContentUtils/api/signUrlClient';
import enviro from 'enviro';
const TEMPLATE_MULTI_PATH = '/_hcms/preview/template/multi';
export const signIfTemplateMulti = url => {
  if (!url || !url.includes(TEMPLATE_MULTI_PATH)) {
    return Promise.resolve(url);
  }
  const parsed = new URL(url);
  const hash = parsed.hash;
  parsed.hash = '';
  // Defensively strip stale hs-* signature params in case the URL was pre-signed (e.g. via UPDATE_PREVIEW_URL)
  for (const key of [...parsed.searchParams.keys()]) {
    if (key.startsWith('hs-')) {
      parsed.searchParams.delete(key);
    }
  }
  return signUrl(parsed.toString(), 'GET').then(({
    signedUrl
  }) => signedUrl + hash).catch(() => url);
};
const buildPreviewUrl = (baseUrl, extraParams = {}) => {
  const params = Object.assign({
    portalId: PortalIdParser.get(),
    revisionPreview: true,
    _preview: true
  }, extraParams);
  return `${baseUrl}?${stringify(params)}`;
};
export const buildRevisionPreviewUrl = (previewDomain, contentId, revisionId, extraParams) => {
  return buildPreviewUrl(`//${previewDomain}/_hcms/preview/content/${contentId}/version/${revisionId}`, extraParams);
};
export const buildStagingRevisionPreviewUrl = (previewDomain, contentId, stagingRevisionId, extraParams) => {
  const params = Object.assign({
    portalId: PortalIdParser.get(),
    revisionPreview: true,
    _preview: true
  }, extraParams, {
    staging_revision_id: stagingRevisionId
  });
  return `//${previewDomain}/_hcms/preview/content/${contentId}?${stringify(params)}`;
};
export const buildStagingDomainUrl = (liveDomainName, slug) => {
  const sanitizedDomain = liveDomainName.replace(/\./g, '-');
  const qaPart = enviro.isQa() ? 'qa' : '';
  const hubletSuffix = enviro.ifHublet({
    isNa1: () => '',
    isNonNa1: hublet => `-${hublet}`
  });
  const stagingDomain = `${sanitizedDomain}.sandbox.hs-sites${qaPart}${hubletSuffix}.com`;
  const normalizedSlug = slug.startsWith('/') ? slug.slice(1) : slug;
  return `https://${stagingDomain}/${normalizedSlug}`;
};
export const buildScheduledUpdateRevisionPreviewUrl = (previewDomain, contentId, revisionBufferId, extraParams) => {
  return buildPreviewUrl(`//${previewDomain}/_hcms/preview/content/${contentId}/buffer/${revisionBufferId}`, extraParams);
};